import React, { Component } from 'react';
import styled from 'styled-components';

const ErrorWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 10px;
  color: #000;
`;

export default class ErrorBoundary extends Component {
  state = {
    error: false,
    info: null
  };

  componentDidCatch(error, info) {
    if (error) {
      this.setState({
        error: true,
        info
      });

      console.log({
        error,
        info
      });
    }
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      return (
        <ErrorWrapper>
          <h2>Her har det skjedd en feil.</h2>
        </ErrorWrapper>
      );
    }

    return children;
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js